module.exports = __webpack_public_path__ + "static/media/notfound.91051414.png";